const BADGE_CLASS = {
  official: "weather-source-badge--official",
  backup: "weather-source-badge--backup",
  estimate: "weather-source-badge--estimate",
  local: "weather-source-badge--local",
  localOfficial: "weather-source-badge--local",
  sensor: "weather-source-badge--local",
  alerts: "weather-source-badge--alerts",
  alert: "weather-source-badge--alerts",
  reference: "weather-source-badge--reference",
  summary: "weather-source-badge--summary",
  internal: "weather-source-badge--internal",
};

const WeatherSourceBadge = ({ tone = "summary", label, className = "" }) => (
  <span
    className={`weather-source-badge ${BADGE_CLASS[tone] || ""} ${className}`.trim()}
  >
    {label}
  </span>
);

export default WeatherSourceBadge;
